var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20.803,
    viewBox: "0 0 24 20.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#8e8e8e;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M577.586,680.159l2.614-3.168V688.4a.8.8,0,1,0,1.6,0V676.961l2.639,3.2a.8.8,0,0,0,1.136,0,.811.811,0,0,0,0-1.141l-3.954-4.793a.924.924,0,0,0-1.216,0l-3.954,4.793a.809.809,0,0,0,0,1.141.8.8,0,0,0,1.135,0ZM592.2,686.8a.8.8,0,0,0-.8.8v5.6H570.6v-5.6a.8.8,0,1,0-1.6,0V694a.8.8,0,0,0,.8.8h22.4a.8.8,0,0,0,.8-.8v-6.4a.8.8,0,0,0-.8-.8Z",
    transform: "translate(-569 -673.996)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.c6150ae6d879743d2c37ce9fd3cc3490.svg";
export { ForwardRef as ReactComponent };